import LangEnum from '../../../../../../lang/LangEnum';
import { TargetUnit } from '../../../../../../services/modules/target/target.types';
import { OrderTargetMeasureColumn } from './orderObjectTargetsTab.types';

export const EMPTY_BLOCK_WIDTH = 320;

export const ORDER_TARGET_MEASURE_COLUMNS: OrderTargetMeasureColumn[] = [
  {
    unit: TargetUnit.GROSS_MONEY,
    plannedName: 'plannedGrossMoney',
    attainedName: 'attainedGrossMoney',
    plannedTitle: LangEnum.GLOBAL_PLANNED_GROSS_VALUE,
    attainedTitle: LangEnum.GLOBAL_ATTAINED_GROSS_VALUE,
  },
  {
    unit: TargetUnit.NET_MONEY,
    plannedName: 'plannedNetMoney',
    attainedName: 'attainedNetMoney',
    plannedTitle: LangEnum.GLOBAL_PLANNED_NET_VALUE,
    attainedTitle: LangEnum.GLOBAL_ATTAINED_NET_VALUE,
  },
  {
    unit: TargetUnit.QUANTITY,
    plannedName: 'plannedQuantity',
    attainedName: 'attainedQuantity',
    plannedTitle: LangEnum.GLOBAL_PLANNED_PIECES,
    attainedTitle: LangEnum.GLOBAL_ATTAINED_PIECES,
  },
];
